import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

export interface IMessage {
    name?: string;
    vorname?: string;
    email?: string;
    textarea?: string;
    unternehmen?: string;
}

@Injectable()
export class MailService {
    private emailUrl = '/assets/email.php';

    constructor(private http: Http) {

    }

    sendEmail(message: IMessage): Observable<IMessage> | any {
        return this.http.post(this.emailUrl, message)
            .map(response => {
                return response;
            })
            .catch(error => {
                return Observable.throw(error);
            });
    }
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/shared/mail.service.ts